import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import emailjs from '@emailjs/browser';

export default function ContactUs() {
  const formRef = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      'service_socmsjv',          // Your EmailJS service ID
      'template_d6m8q38',         // Your EmailJS template ID
      formRef.current,
      'WBdnPACPfEP5ve25i'         // Your EmailJS public key
    )
      .then((result) => {
        console.log('SUCCESS!', result.status, result.text);
        alert('Your message has been sent!');
        formRef.current.reset(); // Clear the form
      }, (error) => {
        console.log('FAILED...', error);
        alert('There was an error sending your message. Please try again later.');
      });
  };

  return (
    <div className='container'>
      <motion.h1 initial={{ opacity: 0 }} animate={{ opacity: 1 }}>Contact Us</motion.h1>

      <motion.form
        ref={formRef}
        onSubmit={handleSubmit}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2 }}
        style={{
          marginTop: '2rem',
          maxWidth: '600px',
          margin: '2rem auto',
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem'
        }}
      >
        <input
          type='text'
          name='from_name'
          placeholder='Your Name'
          required
          style={{ padding: '12px', borderRadius: '8px', border: '1px solid #ccc' }}
        />
        <input
          type='email'
          name='from_email'
          placeholder='Your Email'
          required
          style={{ padding: '12px', borderRadius: '8px', border: '1px solid #ccc' }}
        />
        <textarea
          name='message'
          placeholder='Message'
          required
          rows='6'
          style={{ padding: '12px', borderRadius: '8px', border: '1px solid #ccc' }}
        />
        <button type='submit' className='btn'>Send Message</button>
      </motion.form>
    </div>
  );
}
